// src/components/PackageBanner.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../styles/packageBanner.css";

const packages = [
  {
    id: "pkg1",
    image: process.env.PUBLIC_URL + "/assets/wagonr.png",
    title: "Wagon R – Kurunegala → CMB Airport",
    price: "Rs 11,800",
    note: "Additional Rs 120/km if exceeds limit",
  },
  {
    id: "pkg2",
    image: process.env.PUBLIC_URL + "/assets/prius.png",
    title: "Toyota Prius – Kurunegala → Colombo City",
    price: "Rs 13,500",
    note: "Additional Rs 150/km if exceeds limit",
  },
  {
    id: "pkg3",
    image: process.env.PUBLIC_URL + "/assets/vezel.png",
    title: "Honda Vezel – Kurunegala → Kandy",
    price: "Rs 10,000",
    note: "Additional Rs 180/km if exceeds limit",
  },
  {
    id: "pkg4",
    image: process.env.PUBLIC_URL + "/assets/hiace.png",
    title: "Passenger Van (Hiace) – Kurunegala → Anuradhapura",
    price: "Rs 16,000",
    note: "Additional Rs 200/km if exceeds limit",
  },
];

export default function PackageBanner() {
  return (
    <section className="package-banner">
      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop={true}
        modules={[Autoplay, Pagination]}
      >
        {packages.map((pkg) => (
          <SwiperSlide key={pkg.id}>
            <div className="banner-slide">
              <img src={pkg.image} alt={pkg.title} className="banner-img" />
              <div className="banner-content">
                <h3>{pkg.title}</h3>
                <strong className="banner-price">{pkg.price}</strong>
                <p className="banner-note">{pkg.note}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
